import { useMutation, useQueryClient, useQuery } from 'react-query';
import useAuthStore from '../store/authStore';
import { credentialSignup, signin, signout, signup, verifyAuth } from '../api/auth';

export const useAuth = () => {
  const queryClient = useQueryClient();
  const { setUser, clearUser, setError,} = useAuthStore();

  // Auth verification query
  const { isLoading: isCheckingAuth } = useQuery(
    'authStatus',
    verifyAuth,
    {
      onSuccess: (data) => {
        setUser(data.user);
      },
      onError: (error) => {
        // Only clear user if it's a real error, not just "no token"
        if (error?.response?.status !== 401 || error?.response?.data?.message !== 'No token found') {
          clearUser();
        } else {
          // Just mark as not authenticated without error
          clearUser();
        }
      },
      retry: false,
      // Don't show loading state for quick checks
      notifyOnChangeProps: ['data', 'error']
    }
  );

  const signupMutation = useMutation(signup, {
    onSuccess: (data) => {
      setUser(data.user);
      queryClient.setQueryData('authStatus', data);
    },
    onError: (error) => {
      setError(error?.response?.data?.message || 'Signup failed');
    }
  });

  const signinMutation = useMutation(signin, {
    onSuccess: (data) => {
      setUser(data.user);
      queryClient.setQueryData('authStatus', data);
    },
    onError: (error) => {
      setError(error?.response?.data?.message || 'Signin failed');
    }
  });

  const credentialSignupMutation = useMutation(credentialSignup, {
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      setError(error?.response?.data?.message || 'Credential signup failed');
    }
  });

  const signoutMutation = useMutation(signout, {
    onSuccess: () => {
      clearUser();
      queryClient.clear();
    },
    onError: (error) => {
      setError(error?.response?.data?.message || 'Signout failed');
    }
  });
  

  return {
    signup: signupMutation.mutate,
    credentialSignup: credentialSignupMutation.mutate,
    signin: signinMutation.mutate,
    signout: signoutMutation.mutate,
    isLoading: isCheckingAuth || signupMutation.isLoading || signinMutation.isLoading || credentialSignupMutation.isLoading,
    error: signupMutation.error || signinMutation.error || signoutMutation.error || credentialSignupMutation.error
  };
};